import { useCallback, useEffect, useRef, useState } from "react";

const DEFAULT_TOAST_DURATION_MS = 1500;

export function useAppToast(durationMs = DEFAULT_TOAST_DURATION_MS) {
  const [toastMessage, setToastMessage] = useState("");
  const toastTimeoutRef = useRef(null);

  useEffect(() => {
    return () => {
      if (toastTimeoutRef.current) {
        clearTimeout(toastTimeoutRef.current);
      }
    };
  }, []);

  const showToast = useCallback(
    (message) => {
      setToastMessage(message);

      if (toastTimeoutRef.current) {
        clearTimeout(toastTimeoutRef.current);
      }

      toastTimeoutRef.current = setTimeout(() => {
        setToastMessage("");
      }, durationMs);
    },
    [durationMs],
  );

  return { toastMessage, showToast };
}
